const getRootElement = () => document.getElementById('app');
export default getRootElement;
